// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27I1C","select":"styles_select__1WhxY"};